<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm"
  >
    <div
      class="relative w-full max-w-3xl bg-[#14181F] border border-gray-800 p-6 md:p-8 rounded-[16px] text-white shadow-[0_10px_40px_rgba(0,0,0,0.5)]"
    >
      <!-- Close Button -->
      <button
        @click="$emit('close')"
        class="absolute top-4 right-5 text-gray-500 hover:text-[#00F0FF] text-3xl font-bold transition-colors"
      >
        &times;
      </button>

      <!-- Header -->
      <div class="text-center mb-6 mt-2">
        <h2 class="text-2xl sm:text-3xl font-black text-[#00F0FF] font-oxanium tracking-wide uppercase">
          {{ $t('Modal.StoreTransaction.TransactionHistory') }}
        </h2>
      </div>

      <!-- Transactions -->
      <div
        v-if="transactions && transactions.length > 0"
        class="flex flex-col gap-3 max-h-[400px] overflow-y-auto pr-1 scrollbar-thin"
      >
        <div
          v-for="transaction in transactions"
          :key="transaction._id"
          class="rounded-[10px] bg-[#0D0B10] border border-gray-800 p-4 md:p-5 text-sm leading-snug"
        >
          <!-- Store Type -->
          <div class="flex justify-between items-center">
            <span class="text-[#B9CACB]">{{ $t('Modal.StoreTransaction.StoreType') }} </span>
            <img
              v-if="store"
              :src="
                store === '21.com' || store === '21com'
                  ? require('@/assets/revamp/21com-logo.png')
                  : store === 'kick'
                  ? require('@/assets/kick-logo.png')
                  : ''
              "
              alt="Store Logo"
              class="w-14 h-14 object-contain"
            />
          </div>

          <!-- Product Title -->
          <div class="flex justify-between items-center mt-3 mb-1">
            <span class="text-[#B9CACB]">{{ $t('Modal.StoreTransaction.Product') }}</span>
            <span class="text-[#00F0FF] font-semibold text-right truncate max-w-[60%]">
              {{ transaction.product?.title || $t('Modal.StoreTransaction.UnknownProduct') }}
            </span>
          </div>

          <!-- Ticket Number -->
          <div class="flex justify-between items-center mb-1">
            <span class="text-[#B9CACB]">{{ $t('Modal.StoreTransaction.TicketNumber') }}</span>
            <span class="text-white truncate font-medium text-right font-mono">
              {{ transaction.ticketNumber || "N/A" }}
            </span>
          </div>

          <!-- Transaction Code -->
          <div class="flex justify-between items-center mb-1">
            <span class="text-[#B9CACB]">{{ $t('Modal.StoreTransaction.TransactionCode') }}</span>
            <span class="text-white truncate font-medium text-right font-mono">
              {{ transaction.transactionCode || "N/A" }}
            </span>
          </div>

          <!-- Amount -->
          <div class="flex justify-between items-center mb-1">
            <span class="text-[#B9CACB]">{{ $t('Modal.StoreTransaction.Amount') }}</span>
            <span class="text-[#FFD369] font-semibold text-right">
              {{ transaction.amount.toLocaleString() }}
              {{ transaction.amount > 1 ? $t('Modal.RaffleEntry.Points') : $t('Modal.RaffleEntry.Point') }}
            </span>
          </div>

          <!-- Status -->
          <div class="flex justify-between items-center mb-1">
            <span class="text-[#B9CACB]">{{ $t('Modal.StoreTransaction.Status') }}</span>
            <span
              class="capitalize font-semibold text-right"
              :class="{
                'text-green-400': transaction.status?.toLowerCase() === 'completed',
                'text-yellow-400': ['inprogress', 'pending'].includes(
                  transaction.status?.toLowerCase()
                ),
                'text-red-400': ['declined', 'cancelled'].includes(
                  transaction.status?.toLowerCase()
                ),
                'text-blue-400': transaction.status?.toLowerCase() === 'refunded',
              }"
            >
              {{ transaction.status || "N/A" }}
            </span>
          </div>

          <!-- Timestamp -->
          <div class="flex justify-between items-center mt-2 border-t border-gray-800/50 pt-3">
            <span class="text-[#B9CACB] text-xs">{{ $t('Modal.StoreTransaction.Date') }}</span>
            <span class="text-white/60 text-xs text-right font-semibold">
              {{ new Date(transaction.createdAt).toLocaleDateString() }}
            </span>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <p v-else class="text-center text-white/70 text-sm mt-6">{{ $t('Modal.StoreTransaction.NoTransactions') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    transactions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    store: {
      type: String,
      default: null,
    },
  },
};
</script>

<style>
.scrollbar-thin::-webkit-scrollbar {
  width: 6px;
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 10px;
}
.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}
</style>
